export default __webpack_public_path__ + "static/media/diploma1.af32cefb.jpg";